import React, { useEffect, useState, useRef } from "react";
import BoxComponent from "./BoxComponent";
import {
  TableCellsMerge,
  FileSliders,
  Sheet,
  GitGraph,
  ChartNoAxesCombined,
  Maximize2
} from "lucide-react";
import { Card } from "../ui/Card";
import { UsageTrend } from "./UsageTrend";
import axiosInstance from "../../../axiosInstanceSetup";
import axios from "axios";
import { FaArrowLeft } from "react-icons/fa";
import heartLoading from "../../../assests/heartLoading.gif";
import { ProfilingResultView } from "./ProfilingResult";
import { DQResult } from "./DQResult";
import KeyIcon from "@mui/icons-material/Key";
import Tooltip from "@mui/material/Tooltip";
import AssetConfiguration from "./AssetConfiguration";
import AssetDataTable from "./AssetDataTable";
import SubscriptionModal from "../DataContract/SubscriptionModal";
import { toast, Toaster } from "react-hot-toast";
import ERLandingPage from "../ERDiagram/pages/ERLandingPage";
import ViewLineage from "../DataContract/ViewLineage";
import KpiLineage from "./KpiLineage";
import LineageTransformationViewer from "../DataContract/LineageTransformation/LineageTransformationViewer";
import { CiCircleInfo } from "react-icons/ci";
import { useSearchParams } from "react-router-dom";
import { FiEdit2, FiCheck, FiX } from 'react-icons/fi';


const getTypeColor = (type) => {
  switch (type.toUpperCase()) {
    case "STRING":
      return "primary";
    case "INTEGER":
      return "success";
    case "DECIMAL":
      return "warning";
    case "DATE":
      return "error";
    default:
      return "secondary";
  }
};
const serviceNowTicketLink =
  "https://marsprod.service-now.com/sp?id=incident_helper";

export const AssetsDetails = ({
  subdomain,
  productDetails,
  onBack,
  userRole,
}) => {
  const [searchParams] = useSearchParams();
  const l5 = searchParams.get("l5");

  const [activeTab, setActiveTab] = useState("Data Table");
  const [assetOverview, setAssetOverview] = useState();
  const [assetConfigurationDetails, setAssetConfigurationDetails] = useState();
  const [assetConfigurationLoading, setAssetConfigurationloading] = useState(false);
  const [tableOverview, setTableOverview] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [mermaidDiagrams, setMermaidDiagrams] = useState(null);
  const [mermaidTypes, setMermaidTypes] = useState(null);
  const [selectedMermaid, setSelectedMermaid] = useState(null);
  const [mermaidLoading, setMermaidLoading] = useState(false);
  const [businessSortBy, setBusinessSortBy] = useState("");
  const [businessSortOrder, setBusinessSortOrder] = useState("asc");
  const [businessColumnSearch, setBusinessColumnSearch] = useState({});
  const businessPageRef = useRef(1);
  const [hasInteracted, setHasInteracted] = useState(false);
  const [accumulatedUsers, setAccumulatedUsers] = useState([]);
  const [businessHasMore, setBusinessHasMore] = useState(true);
  const [isFetchingMoreBusiness, setIsFetchingMoreBusiness] = useState(false);
  const [displayDescription, setDisplayDescription] = useState(subdomain.asset_description);
  const [profilingResults, setProfilingResults] = useState();
  const [dqResults, setDqResults] = useState();
const [kpiLineageData, setKpiLineageData] = useState(null);
const [kpiLineageLoading, setKpiLineageLoading] = useState(false);
const [kpiLineageFetched, setKpiLineageFetched] = useState(false);

  // Subscription modal state
  const [showSubscriptionForm, setShowSubscriptionForm] = useState(false);
  const [subscriptionForm, setSubscriptionForm] = useState({
    productName: "",
    projectCode: "",
    readerGroup: "",
    usageDuration: "3months",
    usageDescription: "",
    notificationEmail: "",
    acceptTerms: false,
  });
  const [allFieldsValid, setAllFieldsValid] = useState(true);
  const [formTouched, setFormTouched] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [availableProducts, setAvailableProducts] = useState([]);
  const [editMetadata, setEditMetadata] = useState(false);
  const [usageTrendData, setUsageTrendData] = useState(null);
  const [usageTrendLoading, setUsageTrendLoading] = useState(true);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [tableLoading, setTableLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [editedDescription, setEditedDescription] = useState(subdomain.asset_description);
  const canEditDescription = ['Admin', 'Product Owner', 'Data Steward'].includes(userRole);
  const [isSaving, setIsSaving] = useState(false);



  const fetchAssetInformation = async () => {
    try {
      setTableLoading(true);

      const params = new URLSearchParams();
      const l1 = searchParams.get("l1");
      const l2 = searchParams.get("l2");
      const l3 = searchParams.get("l3");
      const l4 = searchParams.get("l4");
      if (l1) params.append("l1", l1);
      if (l2) params.append("l2", l2);
      if (l3) params.append("l3", l3);
      if (l4) params.append("l4", l4);
      if (l5) params.append("l5", l5);
      if (subdomain.data_asset_id) {
        params.append("id", subdomain.data_asset_id);
      }
      const queryString = params.toString();
      const url = `${process.env.REACT_APP_API_URL}/domain-entity?${queryString}`;

      const response = await axiosInstance.get(url);

      if (response.status === 200) {
        setAssetOverview(response?.data?.assetsOverview);
        setTableOverview(response?.data?.tableDetails);
        setTableLoading(false);
      }
    } catch (e) {
      console.error("getting error whie fetching the asset information");
      setTableLoading(false);
    }
  };

  const fetchProfilingResults = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}/asset_profiling/${subdomain.data_asset_id}`
      );
      if (response.status === 200) {
        setProfilingResults(response?.data);
        setIsLoading(false);
      }
    } catch (e) {
      setProfilingResults({});
      console.error("Error fetching profiling results");
      setIsLoading(false);
    }
  };

  const fetchDQResults = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}/runQuality/assetRuleStatus/${subdomain.data_asset_id}`
      );
      if (response.status === 200) {
        const filteredRules = response.data?.rules?.filter(
          (rule) => rule.rule_name !== "row_count"
        );
        setDqResults(response?.data);
        setIsLoading(false);
      }
    } catch (e) {
      console.error("Error fetching DQ results");
      setIsLoading(false);
    }
  };

  const fetchKpiLineage = async () => {
    try {
      setKpiLineageLoading(true);
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}/kpi-lineage?asset_name=${subdomain.data_asset_name}`
      );
      if (response.status === 200) {
        setKpiLineageData(response.data);
      }
    } catch (err) {
      console.error("Error fetching KPI lineage:", err);
      setKpiLineageData(null);
    } finally {
      setKpiLineageLoading(false);
      setKpiLineageFetched(true);
    }
  };

  const fetchAssetConfiguration = async () => {
    try {
      setAssetConfigurationloading(true);

      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}/view-contracts/${subdomain.data_asset_id}`
      );

      if (response.status === 200) {
        setAssetConfigurationDetails(response.data.data);
        setAssetConfigurationloading(false);
      }
    } catch (e) {
      setAssetConfigurationDetails(null);
      console.error("Error fetching asset configuration");
      setAssetConfigurationloading(false);
    }
  };

  const fetchLineageTransformation = async (assetName) => {
    try {
      setMermaidLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/lineage-transformation?asset_name=${assetName}`
      );
      if (response?.data) {
        setMermaidDiagrams(response.data.mermaid_diagrams);
        const types = response.data.mermaid_diagrams.map((d) => d.name);
        setMermaidTypes(types);
        setSelectedMermaid(response.data.mermaid_diagrams[0]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setMermaidLoading(false);
    }
  };

  const handleSelectMermaid = (mermaidName) => {
    setMermaidLoading(true);
    setTimeout(() => {
      const _selected = mermaidDiagrams.find((d) => d.name === mermaidName);
      setSelectedMermaid(_selected);
      setMermaidLoading(false);
    }, 500);
  };

  const handleBusinessSortChange = (key, order) => {
    setHasInteracted(true);
    businessPageRef.current = 1;
    setAccumulatedUsers([]);
    setBusinessSortBy(key);
    setBusinessSortOrder(order);
  };

  const loadMoreBusinessUsers = async () => {
    if (isFetchingMoreBusiness || !businessHasMore) return;
    businessPageRef.current += 1;
    await fetchUsageTrend(true);
  };

  const handleBusinessSearchChange = (key, value) => {
    setHasInteracted(true);
    businessPageRef.current = 1;
    setAccumulatedUsers([]);
    if (!value) {
      setBusinessColumnSearch({});
    } else {
      setBusinessColumnSearch({ [key]: value });
    }
  };
  const buildUsageTrendParams = () => {
    const params = {
      page: businessPageRef.current,
      page_size: 20,
    };

    const activeSearchKey = Object.keys(businessColumnSearch)[0];

    if (activeSearchKey && debouncedSearch) {
      params.search_by = activeSearchKey;
      params.search_value = debouncedSearch;
    }

    if (businessSortBy) {
      params.sort_by = businessSortBy;
      params.sort_order = businessSortOrder;
    }

    return params;
  };

  const fetchUsageTrend = async (append = false) => {
    try {
      if (append) {
        setIsFetchingMoreBusiness(true);
      } else {
        setUsageTrendLoading(true);
      }

      const params = buildUsageTrendParams();

      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}/data_insights/${subdomain.data_asset_id}`,
        { params }
      );

      if (response.status === 200) {
        const newUsers = response.data?.business_users || [];
        const pag = response.data?.pagination;

        if (append) {
          setAccumulatedUsers((prev) => [...prev, ...newUsers]);
        } else {
          setAccumulatedUsers(newUsers);
          setUsageTrendData(response.data);
        }

        if (pag) {
          setBusinessHasMore(pag.current_page < pag.total_pages);
        } else {
          setBusinessHasMore(false);
        }
      }
    } catch (err) {
      console.error("Error fetching usage trend:", err);
      if (!append) setUsageTrendData({});
      setBusinessHasMore(false);
    } finally {
      if (append) {
        setIsFetchingMoreBusiness(false);
      } else {
        setUsageTrendLoading(false);
      }
    }
  };

  useEffect(() => {
    if (activeTab === "Transformation Lineage") {
      fetchLineageTransformation(subdomain.data_asset_name);
    }
  if (activeTab === "KPI Lineage") {
    fetchKpiLineage();
  }
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === "Usage Trend") {
      businessPageRef.current = 1;
      setAccumulatedUsers([]);
      fetchUsageTrend();
    }
  }, [activeTab]);

  useEffect(() => {
    const activeKey = Object.keys(businessColumnSearch)[0];
    const value = activeKey ? businessColumnSearch[activeKey] : "";

    const timer = setTimeout(() => {
      setDebouncedSearch(value);
    }, 500); // 500ms debounce

    return () => clearTimeout(timer);
  }, [businessColumnSearch]);

  useEffect(() => {
    fetchUsageTrend();
  }, [businessSortBy, businessSortOrder, debouncedSearch]);

  useEffect(() => {
    fetchAssetInformation();
    fetchAssetConfiguration();
    fetchProfilingResults();
    fetchDQResults();
  }, []);

  useEffect(() => {
    fetchAssetInformation();
  }, [editMetadata]);
 const handleSaveDescription = async () => {
  setIsSaving(true);
  try {
    await axiosInstance.put(`${process.env.REACT_APP_API_URL}/description`, {
      type: "asset",
      items: [
        {
          id: subdomain.data_asset_id,
          new_description: editedDescription,
        },
      ],
    });
    setDisplayDescription(editedDescription);
    setIsEditing(false);
  } catch (error) {
    console.error("Error updating description:", error);
  } finally {
    setIsSaving(false);
  }
};

  // Update allFieldsValid whenever form or errors change
  useEffect(() => {
    const isValid =
      subscriptionForm.productName &&
      subscriptionForm.readerGroup &&
      subscriptionForm.usageDuration &&
      subscriptionForm.usageDescription &&
      subscriptionForm.notificationEmail &&
      Object.keys(formErrors).length === 0;
    setAllFieldsValid(isValid);
  }, [subscriptionForm, formErrors]);

  if (isLoading) {
    return (
      <div className="fixed inset-0 bg-white flex items-center justify-center z-50 w-full h-full">
        <div className="flex flex-col items-center space-y-3">
          <img src={heartLoading} alt="Loading..." style={{ width : 200}} />
          <span className="text-gray-700 text-[20px]">
            Please wait while loading the resources...
          </span>
        </div>
      </div>
    );
  }

  const tabs = [
    { id: "Data Table", label: "Assets Table", icon: TableCellsMerge },
    { id: "Data Configuration", label: "Data Contract", icon: Sheet },
    { id: "Profiling Result", label: "Profiling Result", icon: FileSliders },
    { id: "DQResult", label: "Data Quality Result", icon: FileSliders },
    { id: "Technical Lineage", label: "Technical Lineage", icon: GitGraph },
    { id: "KPI Lineage", label: "KPI Lineage", icon: GitGraph },

    {
      id: "Transformation Lineage",
      label: "Transformation Lineage",
      icon: GitGraph,
    },
    { id: "Usage Trend", label: "Usage Trend", icon: ChartNoAxesCombined },

  ];

  const assetData = assetOverview;

  const parseWeightage = (weightageStr) => {
    try {
      return JSON.parse(weightageStr);
    } catch {
      return {};
    }
  };

  const weightage =
    assetData && assetData.weightage && parseWeightage(assetData.weightage);

  // Handle tab click - special handling for Technical Lineage
  const handleTabClick = (tabId) => {
    setActiveTab(tabId);  // just switch tab for both, no modals
  }

  // Subscription handlers
  const handleSubscribe = () => {
    setShowSubscriptionForm(true);
  };

  const closeSubsciptionModal = () => {
    setFormTouched(false);
    setShowSubscriptionForm(false);
    setSubscriptionForm({
      productName: "",
      projectCode: "",
      readerGroup: "",
      usageDuration: "3months",
      usageDescription: "",
      notificationEmail: "",
      acceptTerms: false,
    });
    setFormErrors({});
  };

  const handleSubscriptionChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    setSubscriptionForm((prev) => ({ ...prev, [name]: newValue }));

    // Real-time validation for email field
    if (name === "notificationEmail" && value) {
      const emailRegex = /^[^\s@]+@effem\.com$/;
      if (!emailRegex.test(value)) {
        setFormErrors((prev) => ({
          ...prev,
          notificationEmail: "Only @effem.com email addresses are allowed",
        }));
      } else {
        setFormErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors.notificationEmail;
          return newErrors;
        });
      }
    }
  };

  const validateConfigForm = (formData = subscriptionForm) => {
    const errors = {};
    if (!formData.productName) errors.productName = "Required";
    if (!formData.readerGroup) errors.readerGroup = "Required";
    if (!formData.usageDuration) errors.usageDuration = "Required";
    if (!formData.usageDescription) errors.usageDescription = "Required";
    if (!formData.notificationEmail) {
      errors.notificationEmail = "Required";
    } else {
      const emailRegex = /^[^\s@]+@effem\.com$/;
      if (!emailRegex.test(formData.notificationEmail)) {
        errors.notificationEmail =
          "Only @effem.com email addresses are allowed";
      }
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubscriptionSubmit = () => {
    const trimmedForm = {
      ...subscriptionForm,
      productName: subscriptionForm.productName.trim(),
      projectCode: subscriptionForm.projectCode?.trim() || "",
      readerGroup: subscriptionForm.readerGroup.trim(),
      usageDescription: subscriptionForm.usageDescription.trim(),
      notificationEmail: subscriptionForm.notificationEmail.trim(),
    };

    setSubscriptionForm(trimmedForm);
    setFormTouched(true);
    if (!validateConfigForm(trimmedForm)) return;

    const requestPayload = {
      dataAssetId: subdomain.data_asset_id,
      requestDetails: {
        requestedBy: localStorage.getItem("userId"),
        usageDuration: trimmedForm.usageDuration,
        usageDescription: trimmedForm.usageDescription,
        readerGroup: trimmedForm.readerGroup,
        productName: trimmedForm.productName,
        projectCode: trimmedForm.projectCode || "",
        notificationEmail: trimmedForm.notificationEmail,
      },
    };

    try {
      const response = axios.post(
        `${process.env.REACT_APP_API_URL}/subscription-request`,
        requestPayload,
      );

      if (response.status === 200 || 201) {
        closeSubsciptionModal();
      }

      toast.success("Subscription to the asset configured successfully!");
    } catch (error) {
      toast.error("Failed to subscribe to the asset. Please try again later.");
    }
  };

  // Get available products for subscription form
  const getAvailableProducts = () => {
    // Return fetched products from API
    if (availableProducts.length > 0) {
      return availableProducts;
    }
    // Fallback to current product if API hasn't returned yet
    if (productDetails?.productName) {
      return [productDetails.productName];
    }
    return subdomain.product_name ? [subdomain.product_name] : [];
  };

  return (
    <div className="space-y-8 ">
      <div className="rounded-lg pt-4 pb-4 text-white relative">
        <div className="flex justify-between items-center flex-wrap gap-4 mb-[5px]">
          <h1 className="text-[23px] font-bold text-black break-words whitespace-normal overflow-hidden max-w-[80%]">
            {subdomain.data_asset_name.replace(/\|/g, ".")}
          </h1>
          <button
            onClick={onBack}
            className=" h-[40px] text-[#bb1ccc] hover:text-white transition-colors duration-200 border border-[#bb1ccc] p-2 rounded-lg flex items-center gap-2 hover:bg-[#bb1ccc] hover:shadow-lg px-4 whitespace-nowrap"
          >
            <FaArrowLeft /> Go Back
          </button>
        </div>

        {isEditing ? (
          <>
            <textarea
              value={editedDescription}
              onChange={(e) => setEditedDescription(e.target.value)}
              className="w-full p-3 border border-[#357EDB] rounded-lg text-lg text-black leading-relaxed focus:outline-none focus:ring-2 focus:ring-[#357EDB] mb-3"
              rows="2"
            />
            <div className="flex gap-2 mb-2  ">
             <button
  onClick={handleSaveDescription}
  disabled={isSaving}
  className="flex items-center gap-2 px-4 py-2 bg-[#357EDB] text-white rounded-lg hover:bg-[#357EDB] transition-colors text-sm disabled:opacity-70"
>
  {isSaving ? (
    <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
    </svg>
  ) : (
    <FiCheck size={16} />
  )}
  {isSaving ? "Saving..." : "Save"}
</button>
              <button
                onClick={() => {
                  setIsEditing(false);
                  setIsEditing(false);
                }}
                className="flex items-center gap-2 px-4 py-2 border border-[#357EDB] text-[#357EDB] rounded-lg transition-colors text-sm"
              >
                <FiX size={16} /> Cancel
              </button>
            </div>
          </>
        ) : (
          <p className="text-lg text-black leading-relaxed">
            {displayDescription}
            {canEditDescription && (
              <button
                onClick={() => setIsEditing(true)}
                className="inline p-1 text-[#14B8A6] ml-1"
                title="Edit"
              >
                <FiEdit2 size={14} className="inline" />
              </button>
            )}
          </p>
        )}
        <div className="flex justify-start mb-3 gap-2 items-center flex-wrap">
          <ERLandingPage />
          <div className="flex items-center gap-2">
            <a
              href={serviceNowTicketLink}
              target="_blank"
              className="h-[40px]   px-4 py-2 rounded-lg  border border-[#D8C7E6] flex items-center gap-2 text-[#BE123C]  whitespace-nowrap"
            >
              <CiCircleInfo size={20} className="text-[#BE123C]  text-lg" /> Raise an Incident
            </a>

          </div>
        </div>
        {/* <div className="text-black mt-[10px]">
            {subdomain?.asset_description}
          </div> */}

        {/* Quick Stats */}
        <div className="p-1   bg-[#fff]">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 p-4 rounded-lg">
            <BoxComponent
              value={assetData?.data_asset_score ?? "N/A"}
              label="Data Quality"
              iconBg="#80C6AD"
              cardBg="#E6F1F9"
              iconColor="#fff"
            />

            <BoxComponent
              label="Region"
              iconBg="#9897FF"
              cardBg="#E6F1F9"
              iconColor="#fff"
              value={
                <Tooltip
                  title={
                    assetData ? `${assetData?.region}, ${assetData?.country}` : ""
                  }
                  arrow
                  placement="top"
                >
                  <p className="text-[20px] ">{assetData?.parent_region}</p>
                </Tooltip>
              }
            />

            <BoxComponent
              label="Data Layer"
              iconBg="#0101A7"
              cardBg="#E6F1F9"
              iconColor="#fff"
              value={
                assetData && assetData.target_layer ? (
                  <div
                    className="inline-block px-3 py-1 rounded-full text-sm font-semibold text-center"
                    style={{
                      backgroundColor: (() => {
                        const type = assetData.target_layer.toLowerCase();
                        switch (type) {
                          case "bronze":
                            return "#CD7F32";
                          case "silver":
                            return "#C0C0C0";
                          case "gold":
                            return "#FFD700";
                          case "ingestion":
                            return "#10B981";
                          default:
                            return "#6B7280";
                        }
                      })(),
                      color: (() => {
                        const type = assetData.target_layer.toLowerCase();
                        return type === "gold" || type === "silver" ? "#1f2937" : "white";
                      })(),
                    }}
                  >
                    {assetData.target_layer.charAt(0).toUpperCase() +
                      assetData.target_layer.slice(1).toLowerCase()}
                  </div>
                ) : (
                  <p className="text-sm text-gray-500">N/A</p>
                )
              }
            />

            <BoxComponent
              value={
                <span className="text-[18px]">
                  {assetData?.frequency || "N/A"}
                </span>
              }
              label="Frequency"
              iconBg="#404040"
              cardBg="#E6F1F9"
              iconColor="#fff"
            />
          </div>
        </div>
      </div>

        <div className="border-b border-gray-200 mt-0 ">
          <nav className="flex space-x-8 overflow-x-auto pb-2">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => !tab.disabled && handleTabClick(tab.id)}
                disabled={tab.disabled}
                className={`whitespace-nowrap flex-shrink-0 flex items-center gap-2 py-3 px-1 border-b-2 font-medium text-sm transition-colors ${
                  tab.disabled
                    ? "border-transparent text-gray-300 cursor-not-allowed"
                    : activeTab === tab.id
                      ? "border-[#bb1ccc] text-[#bb1ccc]"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
            >
              <tab.icon size={18} />
              {tab.label}
              {tab.disabled && (
                <span className="text-xs text-gray-400 ml-1">
                  (Coming Soon)
                </span>
              )}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      <div className="space-y-6">
        {activeTab === "Data Table" && (
          <div className="space-y-6">
            {/* Overview Table with built-in search, sort, and pagination */}
            <div className="overflow-x-auto">
              <AssetDataTable
                tableOverview={tableOverview}
                getTypeColor={getTypeColor}
                itemsPerPage={10}
                id={subdomain.data_asset_id}
                setEditMetadata={setEditMetadata}
                loading={tableLoading}
              />
            </div>
          </div>
        )}

        {activeTab === "Profiling Result" && (
          <Card>
            <ProfilingResultView results={profilingResults?.profiling_results?.[0]?.columns || []} />
          </Card>
        )}

        {activeTab === "DQResult" && (
          <Card>
            {dqResults?.rules ? (
              <DQResult results={dqResults} />
            ) : (
              <span>No rules to display</span>
            )}
          </Card>
        )}

        {activeTab === "Data Configuration" && (
          <div className="space-y-6 px-4 max-h-full">
            <AssetConfiguration contractDetails={assetConfigurationDetails}
              contractLoading={assetConfigurationLoading} />
          </div>
        )}
      </div>

      {/* Lineage Modall */}
    {activeTab === "Technical Lineage" && (
<div style={{ width: "100%", height: "80vh" ,minHeight:'30vh',overflowY:'auto'}}>
<ViewLineage
      contractData={{
        name: subdomain.data_asset_name,
        source_type: profilingResults?.profiling_results?.[0]?.source_type,
        filePath: profilingResults?.profiling_results?.[0]?.file_path,
      }}
    />
</div>
)}
 
{activeTab === "KPI Lineage" && (
  <div className="flex flex-col h-full" style={{ width: "100%", position: "relative" }}>
    {subdomain.data_asset_name && (
      <div className="flex items-center gap-2 shrink-0 border-b border-slate-200 px-2 py-2">
        <a
          href={`/kpi-lineage-fullscreen?mode=asset&assetName=${encodeURIComponent(subdomain.data_asset_name)}`}
          target="_self"
          title="View in full screen"
          aria-label="View in full screen"
          className="inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold whitespace-nowrap border border-blue-200 bg-blue-50 text-blue-700 shadow-sm transition-colors hover:border-blue-300 hover:bg-blue-100"
        >
          <Maximize2 className="h-4 w-4" />
          <span>Full screen</span>
        </a>
      </div>
    )}
    <div style={{ width: "100%", height: "80vh", minHeight: "30vh", position: "relative", flex: 1 }}>
      <KpiLineage
        data={kpiLineageData}
        loading={kpiLineageLoading}
        fetched={kpiLineageFetched}
        assetName={subdomain.data_asset_name}
      />
    </div>
  </div>
)}


{activeTab === "Transformation Lineage" && (
<div className="-mt-4" style={{ width: "100%",height: selectedMermaid ? "80vh" : "30vh", display: "flex", flexDirection: "column", minHeight: 0 }}>
    <LineageTransformationViewer
      loading={mermaidLoading}
      assetName={subdomain.data_asset_name}
      selectedMermaid={selectedMermaid}
      mermaidTypes={mermaidTypes || []}
      onSelectMermaid={handleSelectMermaid}
      loadingImage={heartLoading}
      loadingMessage="Loading lineage transformation..."
      emptyMessage="No resources found!"
      emptyTextClassName="text-gray-700 text-[20px]"
      rootClassName="h-full flex flex-col min-h-0"
    />
</div>
)}
{activeTab === "Usage Trend" && (
<div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6">
<UsageTrend
      usageData={usageTrendData}
      loading={usageTrendLoading}
      sortBy={businessSortBy}
      sortOrder={businessSortOrder}
      columnSearch={businessColumnSearch}
      onSortChange={handleBusinessSortChange}
      onSearchChange={handleBusinessSearchChange}
      accumulatedUsers={accumulatedUsers}
      loadMoreBusiness={loadMoreBusinessUsers}
      businessHasMore={businessHasMore}
      isFetchingMoreBusiness={isFetchingMoreBusiness}
      hasInteracted={hasInteracted}
    />
</div>
)}

      {/* Subscription Modal */}
      {showSubscriptionForm && (
        <SubscriptionModal
          selectedAsset={{
            id: subdomain.data_asset_id,
            name: subdomain.data_asset_name,
          }}
          subscriptionForm={subscriptionForm}
          closeSubsciptionModal={closeSubsciptionModal}
          handleSubscriptionSubmit={handleSubscriptionSubmit}
          handleSubscriptionChange={handleSubscriptionChange}
          setShowSubscriptionForm={setShowSubscriptionForm}
          showSubscriptionForm={showSubscriptionForm}
          allFieldsValid={allFieldsValid}
          formTouched={formTouched}
          formErrors={formErrors}
          products={getAvailableProducts()}
        />
      )}

      <Toaster position="top-right" />
    </div>
  );
};
